// this is an autogenerated file from App/Account/Content/Orders/Filters/NextAppointmentTypeChooser/data.graphql
import { gql } from 'Data/Api'

export default gql`
query app__App_Account_Content_Orders_Filters_NextAppointmentTypeChooser($locations: [uuid!]!) {
  vaxiom_appointment_templates(
    where: {
      deleted: { _eq: false }
      organization: { _id: { _in: $locations } }
    }
  ) {
    _id
    appointment_type_id
    appointment_type {
      _id
      display_name
    }
  }
}

`